import { useLocation } from 'react-router';
import store from '../../store';
import { checkIsLtdPlan } from '../design-system/components/molecules/subscription-plan-details/helper/helper';
import { Permissions } from './access-control/enums/permissions';
import hasPermission from './access-control/has-permission';
import { isAgencyUser, getAgencyUserRole } from './user-details';
import { UserRole } from '../enums/user-roles';
import { isFreePlan } from './plans';
import { Routes } from '../../components/home/components/header/header';
import { isPlanDowngradedFromTrial } from '../../components/home/utils/plan-transition';
import { SubscriptionPlans } from './subscription-plans';

export const getUpgradePlanCTA = (isCTAForModal = false) => {
  const state = store.getState();
  const planType = state.home?.subscription?.planType;
  const planTransitionDetails = state.home.subscription?.planTransitionDetails;
  const location = useLocation();
  const path = location.pathname.split('/')?.[1];
  const inboxAnalyzerPlanDetails =
    state?.home?.inboxAnalyzerSubscription?.planCode;
  const inboxAnalyzerStarterPlan = inboxAnalyzerPlanDetails?.split('-')[2];
  const outreachPlanCode = state.home?.subscription?.planCode;
  const leadFinderPlanCode = state?.home?.leadFinderSubscription?.planCode;

  const outreachProPlan = outreachPlanCode && outreachPlanCode.includes('pro');
  const outreachScalePlan =
    outreachPlanCode && outreachPlanCode.includes('scale');
  const leadFinderProPlan =
    leadFinderPlanCode && leadFinderPlanCode.includes('pro');
  const leadFinderScalePlan =
    leadFinderPlanCode && leadFinderPlanCode.includes('scale');
  const inboxAnalyzerScalePlan =
    inboxAnalyzerPlanDetails && inboxAnalyzerPlanDetails.includes('scale');

  const isProOrScalePlan =
    outreachProPlan ||
    outreachScalePlan ||
    leadFinderProPlan ||
    leadFinderScalePlan;

  const remainingInboxAnalyzerEmailSentLimit = parseInt(
    state.home.getPostLoadMetaResponse?.accountUsageQuotaRemaining?.[
      'INBOX_ANALYZER.TESTS'
    ] ?? '0',
    10,
  );

  if (isAgencyUser()) {
    const agencyUserRole = getAgencyUserRole();
    if (agencyUserRole && agencyUserRole === UserRole.AGENCYOWNER) {
      return 'Contact_Support';
    }
    return 'Contact_Owner';
  }

  if (checkIsLtdPlan(planType)) {
    return 'Contact_Support';
  }

  if (!hasPermission(Permissions.ACCOUNT_SUBSCRIPTION_READ)) {
    return 'Contact_Owner';
  }

  if (
    isProOrScalePlan &&
    path === Routes.INBOX_RADAR &&
    inboxAnalyzerPlanDetails === SubscriptionPlans.INBOX_ANALYZER_TRIAL
  ) {
    return 'upgrade_now';
  }

  if (
    inboxAnalyzerStarterPlan &&
    path === Routes.INBOX_RADAR &&
    inboxAnalyzerPlanDetails !== SubscriptionPlans.INBOX_ANALYZER_TRIAL &&
    remainingInboxAnalyzerEmailSentLimit === 0
  ) {
    return 'upgrade_now';
  }

  if (
    inboxAnalyzerStarterPlan &&
    path === Routes.INBOX_RADAR &&
    inboxAnalyzerPlanDetails !== SubscriptionPlans.INBOX_ANALYZER_TRIAL &&
    !inboxAnalyzerScalePlan
  ) {
    return 'upgrade_for_higher_test_limit';
  }

  if (
    inboxAnalyzerStarterPlan &&
    path === Routes.INBOX_RADAR &&
    inboxAnalyzerScalePlan
  ) {
    return '';
  }

  if (isFreePlan()) {
    if (
      path === Routes.LEADS ||
      isPlanDowngradedFromTrial(planTransitionDetails)
    ) {
      return 'upgrade_now';
    }
    if (path === Routes.INBOX_RADAR) {
      return 'upgrade_now';
    }
    return 'resume_email_sending';
  }

  return isCTAForModal ? 'upgrade' : 'upgrade_now';
};
